import React from 'react';

import { Loader } from '@/components/Loader';
import { useEnrichmentPlugins } from '@/sections/customerManagement/components/masterDashboard/hooks/useEnrichmentPlugins';
import { PluginStatusCard } from '@/sections/customerManagement/components/masterDashboard/PluginStatusCard';

export const EnrichmentPluginsPanel: React.FC = () => {
  const { data: plugins, status } = useEnrichmentPlugins();

  if (status === 'pending') {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader />
      </div>
    );
  }

  if (!plugins || plugins.length === 0) {
    return (
      <p className="text-chariot-text-secondary py-8 text-center text-sm">
        No enrichment plugins found. Check backend configuration.
      </p>
    );
  }

  return (
    <div className="grid grid-cols-1 items-start gap-3 md:grid-cols-2 lg:grid-cols-3">
      {plugins.map(plugin => (
        <PluginStatusCard key={plugin.plugin} plugin={plugin} />
      ))}
    </div>
  );
};
